import { useState } from 'react';
import { richieste } from '../../api/acquisti';
import { apri } from '../../lib/ancora';
import { usePuo } from '../sessione/ContestoSessione';

/*  APRIRE UNA RICHIESTA D'ACQUISTO DALLA COMMESSA. 16/10/2026, Galizzi: la richiesta si
    fa sulla commessa, la fa il capocantiere, e l'ufficio acquisti decide da chi
    comprare. Fino a qui la schermata le mostrava ma non permetteva di aprirne una.

    Nasce VUOTA, apposta: «non deve caricare automaticamente, perche' poi tante voci da
    levare». Dentro c'e' il bottone che pesca dal preventivo, e le righe a mano.

    Chiede solo due cose — cosa e per quando — perche' sono le due che chi compra legge
    per prime; il resto si scrive dentro. Appena creata si apre, nella sua schermata.  */
export function NuovaRichiesta({
  commessaId,
  descrizioneCommessa,
}: {
  commessaId: string;
  descrizioneCommessa: string;
}) {
  const puoFare = usePuo();
  const [aperta, setAperta] = useState(false);
  const [descrizione, setDescrizione] = useState(`Materiale per ${descrizioneCommessa}`);
  const [fabbisogno, setFabbisogno] = useState(() => {
    const fra = new Date();
    fra.setDate(fra.getDate() + 7);
    return fra.toISOString().slice(0, 10);
  });
  const [inCorso, setInCorso] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);

  if (!puoFare('CreaRichieste')) return null;

  if (!aperta) {
    return (
      <p className="nuova-richiesta">
        <button type="button" onClick={() => setAperta(true)}>
          + Nuova richiesta d’acquisto
        </button>
      </p>
    );
  }

  async function crea() {
    setInCorso(true);
    setErrore(null);
    try {
      const nata = await richieste.crea({
        commessaId,
        descrizione: descrizione.trim(),
        dataFabbisogno: fabbisogno,
      });
      apri('richieste', nata.id);
    } catch (e) {
      setErrore((e as Error).message);
      setInCorso(false);
    }
  }

  return (
    <div className="nuova-richiesta aperta">
      <label className="campo-blocco">
        <span>Cosa serve</span>
        <input value={descrizione} onChange={(e) => setDescrizione(e.target.value)} />
      </label>
      <label className="campo-blocco">
        <span>Serve il</span>
        <input type="date" value={fabbisogno} onChange={(e) => setFabbisogno(e.target.value)} />
      </label>
      {errore && <p className="errore">{errore}</p>}
      <p className="azioni">
        <button
          type="button"
          className="primario"
          disabled={inCorso || descrizione.trim() === '' || fabbisogno === ''}
          onClick={() => void crea()}
        >
          Apri la richiesta
        </button>
        <button type="button" disabled={inCorso} onClick={() => setAperta(false)}>
          Annulla
        </button>
      </p>
    </div>
  );
}
